import { render } from "./EditClient.vue?vue&type=template&id=0a6e131b&scoped=true&ts=true"
import script from "./EditClient.vue?vue&type=script&lang=ts"
export * from "./EditClient.vue?vue&type=script&lang=ts"

import "./EditClient.vue?vue&type=style&index=0&id=0a6e131b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a6e131b"]])

export default __exports__